<mat-card class="editor-card">
    <mat-card-title class="editor-header">
        <div class="editor-title-group">
            <!-- <span class="editor-kicker">Time Off</span> -->
            <h4 appLocalizationPopupDirective localizationCode="TimeOffPoliciesTypesEditor">{{ 'TimeOffPoliciesTypesEditor' | translate: {Default: "Time Off Type & Policies Editor"} }}</h4>
        </div>

        <div class="editor-header-actions">
            <button
                type="button"
                mat-flat-button
                appPreventDoubleClick (throttledClick)="refreshListener?.cancel()">
                {{ 'Close' | translate: {Default: "Close"} }}
            </button>
        </div>
    </mat-card-title>

    <mat-card-content class="editor-body">
        <section class="type-editor-block">
            <edit-time-off-type [timeOffTypeId]="timeOffType.id" [refreshListener]="refreshListener"></edit-time-off-type>
        </section>

        <section class="policy-section">
            <div class="policy-section-header">
                <div>
                    <!-- <span class="section-label">Assigned policies</span> -->
                    <h5>{{ 'Policies' | translate: {Default: "Policies"} }}</h5>
                </div>

                <button setColor="primaryColour" type="button" mat-stroked-button color="primary" appPreventDoubleClick (throttledClick)="openNewPolicyForm()" class="secondary-action">
                    <mat-icon class="material-icons-outlined" aria-hidden="true">add</mat-icon>
                    {{ 'NewPolicy' | translate: {Default: "New policy"} }}
                </button>
            </div>

            <div class="policy-grid" *ngIf="(timeOffType.policies?.length ?? 0) > 0; else noPolicies">
                <button
                    type="button"
                    class="policy-tile"
                    *ngFor="let policy of timeOffType.policies"
                    appPreventDoubleClick
                    (throttledClick)="openPolicyForm(policy)"
                >
                    <div class="policy-name">{{ policy.name || 'Unnamed policy' }}</div>

                    <div class="policy-meta">
                        <mat-chip
                            *ngIf="policy.accruedAt"
                            [ngClass]="{
                                'yellow-chip': policy.accruedAt?.id === 'StartOfPeriod',
                                'blue-chip': policy.accruedAt?.id === 'EndOfPeriod',
                            }"
                            selected
                        >
                            {{ policy.accruedAt?.name || 'Unnamed policy' }}
                        </mat-chip>
                    </div>
                </button>
            </div>

            <ng-template #noPolicies>
                <div class="no-policies">
                    <p>{{ 'NoPoliciesAvailable' | translate: {Default: "No policies available."} }}</p>
                </div>
            </ng-template>
        </section>

        <ng-container *ngIf="!policy && !isCreatingPolicy; else policyEditor">
            <section class="policy-form-panel empty-policy-state-panel">
                <div class="empty-policy-state">
                    <div class="empty-policy-icon">
                        <mat-icon class="material-icons-outlined" aria-hidden="true">policy</mat-icon>
                    </div>

                    <h5>{{ 'SelectPolicy' | translate: {Default: 'Select a policy'} }}</h5>
                    <p>{{ 'ChooseAPolicyFromTheList' | translate: {Default: 'Choose a policy from the list or create a new one to configure it.'} }}</p>

                    <button type="button" mat-stroked-button color="primary" appPreventDoubleClick (throttledClick)="openNewPolicyForm()" class="secondary-action">
                        <mat-icon class="material-icons-outlined" aria-hidden="true">add</mat-icon>
                        {{ 'NewPolicy' | translate: {Default: 'New policy'} }}
                    </button>
                </div>
            </section>
        </ng-container>

        <ng-template #policyEditor>
            <section class="policy-form-panel" *ngIf="policy || isCreatingPolicy">
                <time-off-policy
                    [timeOffType]="timeOffType"
                    [timeOffPolicyId]="policy?.id"
                    [timeOffTypeList]="timeOffTypeList"
                    [refreshListener]="this"
                    [currentCulture]="currentCulture"
                ></time-off-policy>
            </section>
        </ng-template>
    </mat-card-content>
</mat-card>